"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadToWorkflowNoteDialog = UploadToWorkflowNoteDialog;
var React = _interopRequireWildcard(require("react"));
var _icertis = require("@common/schemas/icertis");
var _button = require("@design/ui/button");
var _dialog = require("@design/ui/dialog");
var _label = require("@design/ui/label");
var _textarea = require("@design/ui/textarea");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var UPLOAD_NOTE_FIELD_ID = "upload-to-workflow-note";
function UploadToWorkflowNoteDialog(_ref) {
  var open = _ref.open,
    note = _ref.note,
    onNoteChange = _ref.onNoteChange,
    onCancel = _ref.onCancel,
    onUpload = _ref.onUpload;
  function submitUpload(event) {
    event.preventDefault();
    onUpload();
  }
  var noteField = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, {
      htmlFor: UPLOAD_NOTE_FIELD_ID,
      children: "Note (optional)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
      id: UPLOAD_NOTE_FIELD_ID,
      "data-autofocus": true,
      className: "min-h-30",
      placeholder: "Add a note for this version...",
      value: note,
      maxLength: _icertis.ICERTIS_UPLOAD_NOTE_MAX_LENGTH,
      onChange: function onChange(event) {
        return onNoteChange(event.target.value);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "self-end text-sm text-muted-foreground",
      children: [note.length, "/", _icertis.ICERTIS_UPLOAD_NOTE_MAX_LENGTH]
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.Dialog, {
    open: open,
    onOpenChange: onCancel,
    "data-sentry-element": "Dialog",
    "data-sentry-component": "UploadToWorkflowNoteDialog",
    "data-sentry-source-file": "UploadToWorkflowNoteDialog.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogContent, {
      "aria-describedby": undefined,
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "UploadToWorkflowNoteDialog.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogHeader, {
        "data-sentry-element": "DialogHeader",
        "data-sentry-source-file": "UploadToWorkflowNoteDialog.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
          "data-sentry-element": "DialogTitle",
          "data-sentry-source-file": "UploadToWorkflowNoteDialog.tsx",
          children: "Upload to workflow"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: submitUpload,
        className: "contents",
        children: [noteField, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogFooter, {
          "data-sentry-element": "DialogFooter",
          "data-sentry-source-file": "UploadToWorkflowNoteDialog.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "outline",
            onClick: onCancel,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "UploadToWorkflowNoteDialog.tsx",
            children: "Cancel"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "submit",
            "data-sentry-element": "Button",
            "data-sentry-source-file": "UploadToWorkflowNoteDialog.tsx",
            children: "Upload"
          })]
        })]
      })]
    })
  });
}